export default "/images/fr.png?8891e6e1a24c3aaba18e6c1c8d0a4775";